import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/dropdown_arrow_white.png'
import _imports_1 from '@/assets/images/noimage_camera.png'


const _hoisted_1 = { class: "pantry-image-room-item-value-view" }
const _hoisted_2 = { class: "pantry-image-room-item-date-view-area" }
const _hoisted_3 = { class: "pantry-image-room-item-date-text" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-image-room-item-date-arrow",
  src: _imports_0
}, null, -1)
const _hoisted_5 = { class: "pantry-image-room-item-no-image" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-image-room-item-no-image-icon",
  src: _imports_1
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _mergeProps({ class: "pantry-image-room-item" }, _ctx.drawScreen, { style: _ctx.imageStyle }), [
    _withDirectives(_createVNode("img", {
      ref: "image",
      class: "pantry-image-room-item-image",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickImage(...args)))
    }, null, 512), [
      [_vShow, !_ctx.isNoImage && !_ctx.isLoading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode("div", {
        class: "pantry-image-room-item-date-view",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickDate(...args)))
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.getDate()), 1),
          _hoisted_4
        ])
      ], 512), [
        [_vShow, _ctx.isShow]
      ])
    ], 512), [
      [_vShow, !_ctx.isNoImage]
    ]),
    _withDirectives(_createVNode("div", _hoisted_5, [
      _hoisted_6
    ], 512), [
      [_vShow, _ctx.isNoImage]
    ])
  ], 16))
}